<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: Presentational
  Reason: Scope badge of one exchange-config carrier row. Colored <span> with PrimeFlex token
    classes rather than p-tag, because in the active KlausPreset every p-tag severity renders in the
    same colour (same choice as the Offline-Upload column on the cw config page).
-->
@if (isInherited()) {
    <span class="inline-flex align-items-center gap-2 text-orange-700 font-medium"
          [pTooltip]="tooltip()"
          tooltipPosition="top">
        <i class="fa-solid fa-code-branch"></i>{{ label() }}
    </span>
} @else {
    <span class="inline-flex align-items-center gap-2 text-color-secondary"
          [pTooltip]="tooltip()"
          tooltipPosition="top">
        <i class="fa-regular fa-file-lines"></i>{{ label() }}
    </span>
}
